import dynamic from 'next/dynamic';

import React, { useEffect } from "react";
const Button = dynamic(() => import('@/components/ui/Button'));
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { useHomeData } from "@/hooks/useHomeData";
import HomeSectionSvgOrange from "../SVGS/Orange.js";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles

export default function HomeSection() {
  const homeData = useHomeData();

  useEffect(() => {
    AOS.init({
      duration: 500, // Animation duration (in milliseconds)
      easing: "ease-in-out", // Animation easing
      once: false, // Whether animation should happen only once
    });
  }, []);

  return (
    <section className="home-section">
      <div className="xl:container mt-8">
        {homeData.map((homeItem, index) => (
          <div
            key={index}
            className={`flex flex-col gap-16 md:flex-row mb-16 ${index % 2 === 1 ? "md:flex-row-reverse" : ""
              }`}
            data-aos="fade-up" // Apply the animation effect here
          >
            <div className="w-full md:w-1/2 flex items-center mb-16 relative">
              <div style={{ position: "relative", zIndex: 1 }}>
                <Image
                  src={homeItem.image.url}
                  alt={homeItem.name}
                  width={500}
                  height={300}
                />
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: -1,
                  }}
                >
                  <HomeSectionSvgOrange />
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2 flex items-center mb-16">
              <div className="text-content">
                <div className="mb-4 text-3xl font-bold text-white text-left gameHeader leading-tight">
                  <div className="flex items-center">
                    <div className="rounded-md overflow-hidden mr-4">
                      <Image
                        src={homeItem.headerImage.url}
                        alt={homeItem.name}
                        width={45}
                        height={45}
                      />
                    </div>
                    <h6>{homeItem.HeaderText}</h6>
                  </div>
                </div>
                <div className="my-8 text-3xl font-bold text-left gameHeader leading-tight">
                  <h5>
                    <span className="text-metaxseed-orange bg-gradient-to-r  bg-clip-text text-fill-color">
                      {homeItem.BodyHeading}
                    </span>
                  </h5>
                </div>

                <div className="text-metaxseed-text-gray text-sm text-pretty gothamBook !leading-relaxed">
                  <PortableText value={homeItem.body} />
                </div>
                <div className="mt-4 w-full md:w-1/2 flex items-end md:items-start">
                  <div>
                    <a href={`${homeItem.ButtonLink}`} target="_blank">
                      <Button className="bg-metaxseed-orange hover:jello-horizontal">
                        {homeItem.ButtonText}
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}